import { __extends } from "tslib";
import { deserializeAws_json1_1SearchFacesByImageCommand, serializeAws_json1_1SearchFacesByImageCommand } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var SearchFacesByImageCommand = /** @class */ (function (_super) {
    __extends(SearchFacesByImageCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function SearchFacesByImageCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    SearchFacesByImageCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {}
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    SearchFacesByImageCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1SearchFacesByImageCommand(input, context);
    };
    SearchFacesByImageCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1SearchFacesByImageCommand(output, context);
    };
    return SearchFacesByImageCommand;
}($Command));
export { SearchFacesByImageCommand };
//# sourceMappingURL=SearchFacesByImageCommand.js.map